import React, { useState } from 'react';
import { Mail, Phone, Send } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const response = await axios.post(`${BACKEND_URL}/api/appointments`, formData);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: '',
      });
      alert('Merci ! Votre demande de rendez-vous a été envoyée avec succès. Nous vous contacterons sous 24h.');
    } catch (error) {
      setSubmitStatus('error');
      console.error('Error submitting appointment:', error);
      alert('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" style={styles.section} className="contact-section">
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={styles.title} className="contact-title">Prendre Rendez-vous</h2>
          <p style={styles.subtitle}>
            Discutons de votre projet et de vos ambitions
          </p>
        </div>

        <div style={styles.content} className="contact-content">
          <div style={styles.formSection} className="contact-form">
            <form onSubmit={handleSubmit} style={styles.form}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Nom Complet *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={styles.input}
                  placeholder="Votre nom"
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={styles.input}
                  placeholder="votre@email.com"
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Téléphone *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  style={styles.input}
                  placeholder="Votre numéro"
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Service Souhaité *</label>
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                  style={styles.select}
                >
                  <option value="">Sélectionnez un service</option>
                  <option value="hospitality">Hospitalité de Luxe</option>
                  <option value="realestate">Immobilier d'Exception</option>
                  <option value="investment">Investissements Stratégiques</option>
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  style={styles.textarea}
                  placeholder="Parlez-nous de votre projet..."
                />
              </div>

              <button 
                type="submit" 
                disabled={isSubmitting}
                style={styles.submitButton}
                className="btn-hover transition-smooth"
              >
                <span>{isSubmitting ? 'Envoi en cours...' : 'Envoyer la Demande'}</span>
                <Send size={20} />
              </button>
            </form>
          </div>

          <div style={styles.infoSection}>
            <div style={styles.infoCard}>
              <h3 style={styles.infoTitle}>Informations de Contact</h3>
              
              <div style={styles.infoItem}>
                <Mail size={24} style={styles.infoIcon} />
                <div>
                  <p style={styles.infoLabel}>Email</p>
                  <a href="mailto:younesnahhas@gmail.com" style={styles.infoValue}>
                    younesnahhas@gmail.com
                  </a>
                </div>
              </div>

              <div style={styles.infoItem}>
                <Phone size={24} style={styles.infoIcon} />
                <div>
                  <p style={styles.infoLabel}>Téléphone</p>
                  <a href="tel:0768211350" style={styles.infoValue}>
                    07 68 21 13 50
                  </a>
                </div>
              </div>
            </div>

            <div style={styles.hoursCard}>
              <h3 style={styles.infoTitle}>Horaires de Consultation</h3>
              <p style={styles.hoursText}>Lundi - Vendredi: 9h00 - 18h00</p>
              <p style={styles.hoursText}>Samedi: Sur rendez-vous</p>
              <p style={styles.hoursText}>Dimanche: Fermé</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '120px 40px',
    background: '#000000',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
  },
  header: {
    textAlign: 'center',
    marginBottom: '80px',
  },
  title: {
    fontSize: '48px',
    fontWeight: '700',
    color: '#FFFFFF',
    marginBottom: '24px',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '20px',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  content: {
    display: 'grid',
    gridTemplateColumns: '1.5fr 1fr',
    gap: '60px',
  },
  formSection: {
    background: '#121212',
    padding: '50px',
    border: '1px solid rgba(212, 175, 55, 0.2)',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#D4AF37',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  input: {
    padding: '14px 16px',
    background: '#000000',
    border: '1px solid rgba(212, 175, 55, 0.3)',
    color: '#FFFFFF',
    fontSize: '16px',
    outline: 'none',
    transition: 'border-color 0.3s ease',
  },
  select: {
    padding: '14px 16px',
    background: '#000000',
    border: '1px solid rgba(212, 175, 55, 0.3)',
    color: '#FFFFFF',
    fontSize: '16px',
    outline: 'none',
    transition: 'border-color 0.3s ease',
  },
  textarea: {
    padding: '14px 16px',
    background: '#000000',
    border: '1px solid rgba(212, 175, 55, 0.3)',
    color: '#FFFFFF',
    fontSize: '16px',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'inherit',
    transition: 'border-color 0.3s ease',
  },
  submitButton: {
    background: '#D4AF37',
    color: '#000000',
    border: 'none',
    borderRadius: '0px',
    padding: '18px 36px',
    fontSize: '18px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    marginTop: '16px',
  },
  infoSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  infoCard: {
    background: '#121212',
    padding: '40px',
    border: '1px solid rgba(212, 175, 55, 0.2)',
  },
  hoursCard: {
    background: '#121212',
    padding: '40px',
    border: '1px solid rgba(212, 175, 55, 0.2)',
  },
  infoTitle: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#FFFFFF',
    marginBottom: '30px',
  },
  infoItem: {
    display: 'flex',
    gap: '20px',
    marginBottom: '24px',
  },
  infoIcon: {
    color: '#D4AF37',
    flexShrink: 0,
  },
  infoLabel: {
    fontSize: '12px',
    color: 'rgba(255, 255, 255, 0.5)',
    marginBottom: '4px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  infoValue: {
    fontSize: '18px',
    color: '#FFFFFF',
    textDecoration: 'none',
  },
  hoursText: {
    fontSize: '16px',
    color: 'rgba(255, 255, 255, 0.85)',
    marginBottom: '12px',
    lineHeight: '1.6',
  },
};